import { axiosInstance } from "../axiosUtil";

import getAuthHeader from "../Auth/GetAuthHeader";

class ClientService {
  getUserClients() {
    const headers = {
      Authorization: getAuthHeader(),
    };

    return axiosInstance.get("api/v1/clients", { headers }).then((response) => {
      return response.data;
    });
  }
}

export default new ClientService();
